import(/* webpackMode: "eager" */ "/vercel/path0/src/app/universities-spain/page.tsx");
